import { render } from "./LoadingContainer.vue?vue&type=template&id=78304b0c"
import script from "./LoadingContainer.vue?vue&type=script&lang=js"
export * from "./LoadingContainer.vue?vue&type=script&lang=js"

import "./LoadingContainer.vue?vue&type=style&index=0&id=78304b0c&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__